import React, { useEffect, useState } from 'react';
import { Button, TextField, Paper, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { browserHistory } from 'react-router'
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import './signup.css';
import { adminService } from "@tuqqi/common";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withAuth0 } from '@auth0/auth0-react';
import { loadOrganizationData } from '../../../utils/loadOrganizationData';
import { persistor } from '../../..';
// import { managerTableKeepGlobalData } from '@tuqqi/web';

export const STEP_ONE = "step1";
export const STEP_TWO = "step2";
export const STEP_THREE = "step3";
export const STEP_FOUR = "step4";
export const STEP_FIVE = "step5";

const Card = ({ icon, title, description, avatar, onClick, isSelected }) => {
    return (
        <div className={`card ${isSelected ? 'selected' : ''}`} onClick={onClick}>
            <div className="icon">{icon}</div>
            <div className="text">
                <h3>{title}</h3>
                <p>{description}</p>
            </div>
            {avatar && <div className="avatar">{avatar}</div>}
        </div>
    );
};


const languageOptions = [
    { value: 'en-US', label: 'English (United States)' },
    { value: 'es-ES', label: 'Spanish (Spain)' },
    { value: 'de-DE', label: 'German (Germany)' },
    { value: 'he-IL', label: 'Hebrew (Israel)' },
    { value: 'pt-BR', label: 'Portuguese (Brazil)' },
    // Add more language options as needed
];

const LanguageSelect = (props) => {
    // const handleChange = (event) => {
    //     setLanguage(event.target.value);
    // };

    return (
        <FormControl variant="outlined" fullWidth>
            <InputLabel id="language-select-label">Language</InputLabel>
            <Select
                labelId="language-select-label"
                id="language-select"
                value={props.language}
                onChange={props.handleChange}
                label="Language"
            >
                {languageOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

const SignupPage = (props) => {
    const { services, auth0, dispatch } = props;
    const [user, setUser] = useState(null);
    const [orgName, setOrgName] = useState('');
    const [activeStep, setActiveStep] = useState(0);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [language, setLanguage] = useState('en-US');
    const [isThirdPartyLogin, setIsThirdPartyLogin] = useState(false);
    const [templateName, setTemplateName] = useState(null);
    const [isLoading, setIsLoading] = useState(true);



    const signupSuccess = async () => {
        const claims = await auth0.getIdTokenClaims();

        try {
            await loadOrganizationData(claims.__raw, dispatch)
            // await sleep(1000)
            await persistor.persist()
            // await sleep(1000)
            await window.location.reload();
        } catch (error) {
            console.log(error);
        }
    }


    useEffect(() => {

        // console.log(props.userData);
        // get user first name and last name from auth0 id token





        const fetchData = async () => {

            const idToken = await auth0.getIdTokenClaims();
            const { given_name = '', family_name = '' } = idToken ?? {};



            const isGoogleLogin = idToken?.sub?.includes('google');
            const isMicrosoftLogin = idToken?.sub?.includes('live.com'); // Example, adjust based on actual identifier

            setIsThirdPartyLogin(isGoogleLogin || isMicrosoftLogin);


            setFirstName(given_name);
            setLastName(family_name);

            services.userSettingsService.getUser().then(user => {
                setUser(user);
                // if (user.status === 'USER_NOT_FOUND') {
                //     // start registration                    
                //     setActiveStep(0);
                // } else {
                //     setActiveStep(1);
                // }
            })

        };

        fetchData();
    }, []);

    const steps = ['You', 'Your Organization', 'Get Started'];

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const signupSteps = async ()=>{
        if (!user.org) { await services.signupService.createOrganizationStep1({ title: orgName, templateName: templateName }); }
        if (!user.org || user.org.templateName === STEP_TWO) { await services.signupService.createOrganizationStep2(); }
        if (!user.org || user.org.templateName === STEP_THREE) { await services.signupService.createOrganizationStep3(); }
        if (!user.org || user.org.templateName === STEP_FOUR) { await services.signupService.createOrganizationStep4(); }

        await services.signupService.createOrganizationStep5();

        // redirect to feed
        // browserHistory.push('/feed');
        await signupSuccess();
    }


    const handleNext = async () => {

        switch (activeStep) {

            case 2:


                setIsLoading(true);

                if (user.status === 'USER_NOT_FOUND') {
                    // start registration                    
                    adminService.createAdminSignUp( firstName, lastName, language ).then((response) => {
                        // console.log(response);
                        
                        
                        signupSteps().then(()=>{
                            setActiveStep((prevActiveStep) => prevActiveStep + 1);
                            setIsLoading(false);

                        })
                    });
                }else{
                    await signupSteps();
                }                

              

                break;
            default:
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                break;

        }




    };
    const getNextButtonDisabled = () => {
        switch (activeStep) {
            case 0:
                return firstName === '' || lastName === '';
            case 1:
                return orgName === '';
            case 2:
                return !!!templateName;
            default:
                return false;
        }
    }

    const handleChange = (event) => {
        setFirstName(event.target.value);
    };

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return firstStep;
            case 1:
                return secondStep;
            case 2:
                return thirdStep;
            default:
                return 'Unknown step';
        }
    }

    const handleCardClick = (cardTitle) => {
        setTemplateName(cardTitle);
    };

    const firstStep = <Paper>
        <h2>You</h2>
        <p>We want to get to know you...</p>
        <TextField
            label="Your Name?"
            value={firstName}
            onChange={handleChange}
            variant="outlined"
            disabled={isThirdPartyLogin && firstName}
            fullWidth
        />
        <br />
        <br />
        <TextField
            label="Your surname?"
            value={lastName}
            onChange={(event) => { setLastName(event.target.value) }}
            variant="outlined"
            disabled={isThirdPartyLogin && lastName}
            fullWidth
        />
        <br />
        <br />
        <LanguageSelect language={language} handleChange={(event) => { setLanguage(event.target.value) }} />
    </Paper>

    const secondStep = <Paper>
        <h2>Your Organization</h2>
        <p>What's the name of your organization?</p>
        <TextField
            label="Organization Name?"
            value={orgName}
            onChange={(event) => { setOrgName(event.target.value) }}
            variant="outlined"
            fullWidth
        />
        <br />
        <br />
    </Paper>

    const thirdStep = <Paper>
        <h2>Get Started</h2>
        <p>Let's get started...</p>

        <div>
            <h3>Choose a template</h3>
        </div>

        <div className="container">
            <Card
                icon={<span role="img" aria-label="icon">✨</span>}
                title="SaaS"
                description="All network infrastructure and computing platforms provided. Just sign up and use the services."
                onClick={() => handleCardClick("SaaS")}
                isSelected={templateName === "SaaS"}
            />
            <Card
                icon={<span role="img" aria-label="icon">🌐</span>}
                title="SaaS"
                description="All network infrastructure and computing platforms provided. Just sign up and use the services."
                onClick={() => handleCardClick("SaaS")}
                isSelected={templateName === "SaaS"}
            />
            <Card
                icon={<span role="img" aria-label="icon">🌐</span>}
                title="SaaS"
                description="All network infrastructure and computing platforms provided. Just sign up and use the services."
                onClick={() => handleCardClick("SaaS")}
                isSelected={templateName === "SaaS"}
            />
            <Card
                icon={<span role="img" aria-label="icon">📋</span>}
                title="On-premise deployment"
                description="Local or private cloud deployment. Users provide the infrastructure; we provide tailored software solutions."
                onClick={() => handleCardClick("On-premise deployment")}
                isSelected={templateName === "On-premise deployment"}
            />
            <Card
                icon={<span role="img" aria-label="icon">👤</span>}
                title="Help Me Get Started"
                description="Book a meeting with an expert to help you get started with our system."
                avatar={<img src="path_to_avatar.jpg" alt="avatar" />}
                onClick={() => handleCardClick("Help Me Get Started")}
                isSelected={templateName === "Help Me Get Started"}
            />
            <Card
                icon={<span role="img" aria-label="icon">👤</span>}
                title="Help Me Get Started"
                description="Book a meeting with an expert to help you get started with our system."
                avatar={<img src="path_to_avatar.jpg" alt="avatar" />}
                onClick={() => handleCardClick("Test")}
                isSelected={templateName === "Test"}
            />
            {templateName && <div className="selected-message">Selected Card: {templateName}</div>}
        </div>

    </Paper>

    //https://www.figma.com/design/NKGA4xQuENHYk7Exp6hPoX/padX-client-App?node-id=2-208869&m=dev
    // npx figma connect create "https://www.figma.com/design/NKGA4xQuENHYk7Exp6hPoX/padX-client-App?node-id=2-208869&m=dev" --token figd_l2SI0L2EQnfW2ntEgir-zGEIAYvTj4UMTyDq6cZi
    return (
        <div className='signup-container'>
            <Paper sx={{ width: '100%', textAlign: 'center', mt: 4 }} className='signup-paper'>
                <Stepper activeStep={activeStep} className='signup-stepper'>
                    {steps.map((label, index) => (
                        <Step key={index}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <Paper sx={{ mt: 4 }}>
                    {getStepContent(activeStep)}
                </Paper>
                <Paper sx={{ mt: 2 }}>
                    <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        sx={{ mr: 1 }}
                    >
                        Back
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={getNextButtonDisabled()}
                        onClick={handleNext}
                    >
                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                    </Button>
                </Paper>
            </Paper>
        </div>
    );
};


const mapStateToProps = (state, ownProps) => ({
    userData: state.userData,
    authService: state.authModule.authService,
    services: state.services
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch: dispatch
    }
}

export default compose(
    withAuth0,
    connect(
        mapStateToProps,
        mapDispatchToProps
    ))(SignupPage);



// export default SignupPage;